import { render, staticRenderFns } from "./InsertDeadAla.vue?vue&type=template&id=615c8644"
import script from "./InsertDeadAla.vue?vue&type=script&lang=js"
export * from "./InsertDeadAla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports